import { Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";

const infoManual = (
  <Box>
    <Stack mb={5}>
      <Typography>
        　社会福祉施設職員等退職手当共済制度（当制度）のほかに都道府県社会福祉協議会等が運営する退職金共済制度に加入されている場合、
      </Typography>
      <Typography>
        掛金納付対象職員届の確定したデータ（自法人分の情報すべて）を
        <Link
          className="LinkName"
          target="_blank"
          to={
            "https://www.wam.go.jp/hp/wp-content/uploads/kyousai-syakyou20220401.pdf"
          }
        >
          施設所在地の都道府県の社会福祉協議会等
        </Link>
        にシステム上で提供することが可能です。
      </Typography>
      <Typography>
        　なお、個人情報が含まれるため、事前に被共済職員への同意を取得いただくことが必要です。
      </Typography>
      <Typography>
        　希望される場合は、「データ提供することに被共済職員の同意を取得済み」に☑を入れ、「データを提供」ボタンをクリックしてください。
      </Typography>
      <Typography>
        　※提供は８月となるため、それ以前に提供が必要な場合は、掛金納付対象職員届の控えをダウンロードすることでの対応をお願いします。
      </Typography>
    </Stack>
  </Box>
);

export { infoManual };
